export default [
  {
    title: 'Campaign',
    komicon: 'k-share-1',
    resource: 'Campaign',
    route: 'notification',
    action: 'manage',
  },
]
